import Icon from '../components/Icon.vue'

Icon.register({
  'user-times': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M589.6 240L635.2 194.4C641.5 188.1 641.5 177.9 635.2 171.6L612.4 148.8C606.1 142.5 595.9 142.5 589.6 148.8L544 194.4 498.4 148.8C492.1 142.5 481.9 142.5 475.6 148.8L452.8 171.6C446.5 177.9 446.5 188.1 452.8 194.4L498.4 240 452.8 285.6C446.5 291.9 446.5 302.1 452.8 308.4L475.6 331.2C481.9 337.5 492.1 337.5 498.4 331.2L544 285.6 589.6 331.2C595.9 337.5 606.1 337.5 612.4 331.2L635.2 308.4C641.5 302.1 641.5 291.9 635.2 285.6L589.6 240zM224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 348.2 387.8 288 313.6 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-times.js
// module id = Gtmm
// module chunks = 144